import { Row, Col, Stack, SubHeading } from '@workramp/ui';
import { I18n } from '~/common/explicit-exports';
import { SourceItem as StyledSourceItem } from '../LearnerAIQuestionAnswer.styles';
import { type ContentTypes, SourceItem as SourceItemComponent } from './SourceItem';

export interface Source {
  id: string;
  title: string;
  content_type: ContentTypes;
}

interface SourcesListProps {
  sources: Source[];
  variant: 'dropdown' | 'advanced';
  showTitle?: boolean;
  isAcademy?: boolean;
}

export const SourcesList = ({ sources, variant, showTitle = true, isAcademy }: SourcesListProps) => {
  const SOURCES_TITLE = I18n.t('js.learner.ai_search.sources_title');

  if (sources.length === 0) {
    return null;
  }

  if (variant === 'dropdown') {
    // Horizontal layout for dropdown view
    return (
      <Row gapX={2} gapY={3}>
        {sources.map(({ id, title, content_type }) => (
          <Col xs="auto" key={id}>
            <SourceItemComponent id={id} title={title} contentType={content_type} isAcademy={isAcademy} />
          </Col>
        ))}
      </Row>
    );
  }

  // Vertical layout for advanced view
  return (
    <Stack size={showTitle ? 3 : 2}>
      {showTitle && <SubHeading level="md">{SOURCES_TITLE}</SubHeading>}
      <div>
        {sources.map(({ id, title, content_type }, index) => (
          <StyledSourceItem key={id} isLast={index === sources.length - 1}>
            <SourceItemComponent id={id} title={title} contentType={content_type} isAcademy={isAcademy} />
          </StyledSourceItem>
        ))}
      </div>
    </Stack>
  );
};
